import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import API_URL from '../config';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true); // Para saber quando a verificação inicial terminou

    useEffect(() => {
        const checkAuth = async () => {
            try {
                const response = await axios.get(`${API_URL}/@me`, {
                    withCredentials: true,
                });
                if (response.status === 200 && response.data?.id) {
                    setIsAuthenticated(true);
                    setUser(response.data);
                } else {
                    setIsAuthenticated(false);
                    setUser(null);
                }
            } catch (error) {
                setIsAuthenticated(false);
                setUser(null);
            } finally {
                setLoading(false);
            }
        };
        checkAuth();
    }, []);

    const login = async (username, password) => {
        try {
            const response = await axios.post(`${API_URL}/login`, { username, password }, {
                withCredentials: true
            });
            if (response.status === 200) {
                setIsAuthenticated(true);
                setUser(response.data);
                return true;
            }
            return false;
        } catch (error) {
            console.error("Login failed:", error);
            setIsAuthenticated(false);
            setUser(null);
            throw error; // Propagar erro para exibir no formulário
        }
    };

    const logout = async () => {
        try {
            await axios.post(`${API_URL}/logout`, {}, {
                withCredentials: true
            });
            setIsAuthenticated(false);
            setUser(null);
        } catch (error) {
            console.error("Logout failed:", error);
        }
    };

    return (
        <AuthContext.Provider value={{ isAuthenticated, user, loading, login, logout, setIsAuthenticated, setUser }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);